/**
 * @group Constants
 *
 * @summary
 * <blockquote>HTTP headers used to pass mobile app version metadata for enforcement.</blockquote>
 *
 * @example
 * ```typescript
 * const headerName = VERSION_GATE_REQUEST_HEADERS.APP_VERSION;
 * ```
 */
export const VERSION_GATE_REQUEST_HEADERS = {
  PLATFORM: 'x-phila-platform',
  APP_VERSION: 'x-phila-app-version',
  APP_VERSION_CODE: 'x-phila-app-version-code',
} as const;
